import { Pagination } from '@/api/pagination';
import { of, Observable, async } from 'rxjs';
import { map } from 'rxjs/operators';
import { PerfilAPI } from '@/api/perfil.api';
import { Perfil } from '@/models/perfil';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';

const api = new PerfilAPI();

const list = (params: any): Observable<any> => {
  return api.list(params);
}

const show = (id: number): AxiosObservable<Perfil> => {
  return api.show(id);
}

const create = (perfil: any): AxiosObservable<Perfil> => {
  const body = {
    name: perfil.name,
    key: perfil.key,
  };

  return api.create(body)
}

const update = (id: number, perfil: any): AxiosObservable<Perfil> => {
  const body = {
    name: perfil.name,
    key: perfil.key,
  };

  return api.update(id, body)
}

const addFunctionality = (profileId: number, functionalityId: number): AxiosObservable<any> => {
  const body = { profile_functionality: { functionality_id: functionalityId } };

  return api.addFunctionality(profileId, body);
}

const listFunctionalities = (profileId: number, params: any): AxiosObservable<any> => {
  return api.listFunctionalities(profileId, params);
}

const removeFunctionality = (profileId: number, functionalityId: number): AxiosObservable<any> => {
  return api.removeFunctionality(profileId, functionalityId);
}

export default {
  show,
  create,
  update,
  list,
  addFunctionality,
  removeFunctionality,
  listFunctionalities
}
